import { defineComponent, openBlock, createElementBlock, normalizeClass, renderSlot, createTextVNode, toDisplayString, createCommentVNode } from 'vue';

var script = defineComponent({
    name: 'Label',
    props: {
        /** Label text */
        label: { type: String, default: '' },
        /** Alternative for the 'for' attribute  */
        htmlFor: { type: String, default: undefined },
        /** Prefix all classes in every element with this string */
        prefix: { type: String, default: '' },
        /** Extra symbol or text for marking the required field */
        reqText: { type: String, default: '' }
    }
});

const _hoisted_1 = ["for"];

function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createElementBlock("label", {
    class: normalizeClass(_ctx.$attrs.class),
    for: _ctx.htmlFor
  }, [
    renderSlot(_ctx.$slots, "default", {}, () => [
      createTextVNode(toDisplayString(_ctx.label), 1 /* TEXT */)
    ]),
    (_ctx.$slots.reqText || _ctx.reqText)
      ? (openBlock(), createElementBlock("em", {
          key: 0,
          class: normalizeClass(`${_ctx.prefix}required`)
        }, [
          renderSlot(_ctx.$slots, "reqText", {}, () => [
            createTextVNode(toDisplayString(_ctx.reqText), 1 /* TEXT */)
          ])
        ], 2 /* CLASS */))
      : createCommentVNode("v-if", true)
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}

script.render = render;
script.__file = "packages/vue/label/lib/Label.vue";

export { script as default };
